import { useMemo } from 'react';
import { QueueGroupSummary } from '@hone-automation/common';
import { useQueueContext } from '../Queue/QueueContext';

export interface GroupItem {
  id: string;
  name: string;
  requestCount: number;
}

/**
 * Hook for getting available groups
 *
 * Gets groups from viewCounts (fetched by QueueContext for all views).
 *
 * @returns Array of GroupItem objects
 */
export const useGroups = (): GroupItem[] => {
  const { queryData } = useQueueContext();
  const { viewCounts } = queryData;

  const groups = useMemo(() => {
    const groupsData: QueueGroupSummary[] = viewCounts?.Groups ?? [];
    return groupsData.map(g => ({ id: g.id, name: g.name, requestCount: Number(g.requestCount || 0) }));
  }, [viewCounts]);

  return groups;
};
